export default "__VITE_ASSET__Bb2uMtB1__"